import { ofType } from 'redux-observable';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import JobProApi from '../../dependencies/JobProApi';
import schedulerStorage from '../../dependencies/Storage';

const EMPLOYEE_FIELDS = 'id,resourceId,firstName,lastName';

// Action types
const FETCH_AVAILABLE_EMPLOYEES = 'FETCH_AVAILABLE_EMPLOYEES';
const FETCH_AVAILABLE_EMPLOYEES_COMPLETE = 'FETCH_AVAILABLE_EMPLOYEES_COMPLETE';
const SEARCH_EMPLOYEES = 'FETCH_EMPLOYEES';
const SEARCH_EMPLOYEES_COMPLETE = 'FETCH_EMPLOYEES_COMPLETE';
const UPDATE_SEARCH_CRITERIA = 'UPDATE_SEARCH_CRITERIA_EMPLOYEES';
const SET_EMPLOYEE_TOGGLE = 'SET_EMPLOYEE_TOGGLE';



const DEFAULT_STATE = {
    employees: [],
    selected_employees:[], // Selected employees to show only  job of these employees
    form: {
        query: '',      
      },
      loading: false,
      employeeToggle:{
       togleState: false,
       toggleClass:'fa fa-chevron-right'
      },
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case FETCH_AVAILABLE_EMPLOYEES:
      return {
        ...state,
        employees: [],
        loading: true
      };
    case FETCH_AVAILABLE_EMPLOYEES_COMPLETE:
      return {
        ...state,
        ...payload,
        loading: false
      };

      case SEARCH_EMPLOYEES:
        return {
          ...state,
          employees: {
            employees: [],
            loading: true
          }
        };
      case SEARCH_EMPLOYEES_COMPLETE:
        return {
          ...state,
          employees: {
            employees: payload.employees,
            loading: false
          }
        };
      case UPDATE_SEARCH_CRITERIA:
        return {
          ...state,
          form: {
            ...state.form,
            ...payload
          },
          loading: true
        };
      case SET_EMPLOYEE_TOGGLE:

        return {
          ...state,
          form: {
            ...state.form,            
          },
          loading: false,
          employeeToggle:payload
        };
     
    default:
      return state;
  }
}

// Action creators:

export const fetchAvailableEmployees = () => ({
  type: FETCH_AVAILABLE_EMPLOYEES,
  
});

const fetchAvailableEmployeesComplete = (employees) => ({
  type: FETCH_AVAILABLE_EMPLOYEES_COMPLETE,
  payload: { 
    employees 
    
}
});

export const searchEmployees = (query) => ({
    type: SEARCH_EMPLOYEES,
    payload: { query }
  });

export const setEmployeeToggle = (toggle) => ({
    type: SET_EMPLOYEE_TOGGLE,
    payload:  toggle 
  });
  
  const searchEmployeesComplete = (employees) => ({
    type: SEARCH_EMPLOYEES_COMPLETE,
    payload: { employees }
  });

  export const updateSearchCriteria = (criteria) => ({
    type: UPDATE_SEARCH_CRITERIA,
    payload: criteria
  });
 export const updateSelectedEmployeeList = (payload)=>(
 {
  type:UPDATE_SELECTED_EMPLOYEE_LIST,
  payload : {payload}

 })


// Epics
export const fetchAvailableEmployeesEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_AVAILABLE_EMPLOYEES, UPDATE_SEARCH_CRITERIA),
  debounceTime(300),
  switchMap(() => {

    const { query } = state$.value.searchEmployees.form;
        
       const criteria = {
        isActive: true,         
    };    
    
    if(state$.value.settings.entity === 'appointments')
    {
    if(state$.value.searchAppointments.form.offices && state$.value.searchAppointments.form.offices.length > 0 )
    {
      criteria.office = state$.value.searchAppointments.form.offices.map((o) => o.name);
    }
    }
    else if(state$.value.settings.entity === 'jobs')
    {
    if(state$.value.searchJobs.form.offices && state$.value.searchJobs.form.offices.length > 0 )
    {
      criteria.office = state$.value.searchJobs.form.offices.map((o) => o.name);
    }
    }

    
    if(state$.value.settings.entity !== 'appointments')
    {
      criteria.isJobAssignee = true
    }
    if (query) {
       
        criteria.employeequery = query;
      }
    
    return JobProApi.employees.query(criteria, {
      fields: EMPLOYEE_FIELDS,      
    });
  }),
  map(fetchAvailableEmployeesComplete),
);

 export const searchEmployeessEpic = (action$, state$) => action$.pipe(
  ofType(SEARCH_EMPLOYEES),
  debounceTime(300),
  switchMap(({ payload }) => {
    const criteria = {
      isActive: true,      
  };

  if(state$.value.settings.entity !== 'appointments')
  {
    criteria.isJobAssignee = true
  }

  if (payload) {     
      criteria.employeequery = payload;
    }   
    return JobProApi.employees.query({
      criteria
    }, {
        fields: EMPLOYEE_FIELDS,        
      });
  }),
  map(searchEmployeesComplete),
); 
